// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableWidget_wrapper__3uSoo","toolbar":"TableWidget_toolbar__Bew8l"};